import { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import '../Css/DeliveryChart.css';
import Logger from './Logger';
import { getLoggerBaseURL } from '../utils/getLoggerBaseURL';

// Initialize Logger
const logger = new Logger(getLoggerBaseURL());

const DeliveryChart = () => {
  const [driverData, setDriverData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const adminEmail = sessionStorage.getItem('adminEmail');
      const res = await fetch(`/api/driver/getdelivery/${adminEmail}`);

      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      const data = await res.json();
      setDriverData(data);
    } catch (error) {
      logger.log(`Error fetching data: ${error.message}`, 'ERROR');
    }
  };

  const driverNames = driverData.map(driver => driver.name);
  const totalDeliveries = driverData.map(driver => driver.totalDeliveries);

  const chartData = {
    labels: driverNames,
    datasets: [
      {
        label: 'Total Deliveries',
        data: totalDeliveries,
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    plugins: {
      tooltip: {
        enabled: true,
      },
      hover: {
        mode: 'nearest',
        intersect: true,
      },
    },
    scales: {
      x: {
        type: 'category',
        title: {
          display: true,
          text: 'Drivers',
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Total Deliveries',
        },
      },
    },
  };

  return (
    <div className="graph-container">
      <canvas className="chart-canvas"></canvas>
      <div className='graphShow'>
        <Bar data={chartData} options={chartOptions} />
      </div>
    </div>
  );
};

export default DeliveryChart;
